/* VerifiedBadge — شارة تَوثيق واحِدة (LinkedIn-style).
   تَظهَر فَقط للمحامي صاحب البِطاقة المَسحوبة + السّارية. */
import { SealCheck } from "@phosphor-icons/react";

export function HotChip({ size = "sm" }) {
  const pad = size === "xs" ? "px-1.5 py-0.5 text-[9.5px]" : "px-2 py-0.5 text-[10.5px]";
  return (
    <span
      data-testid="hot-chip"
      title="الأَكثَر نَشاطاً في المُحافَظة هذا الشَّهر"
      className={`inline-flex items-center gap-1 rounded-full font-bold ${pad}`}
      style={{
        background: "linear-gradient(135deg, #F97316 0%, #DC2626 100%)",
        color: "#fff",
        boxShadow: "0 2px 8px rgba(220,38,38,0.35)",
      }}
    >
      <span className="leading-none">🔥</span>
      <span className="leading-none">الأَكثَر نَشاطاً</span>
    </span>
  );
}

export default function VerifiedBadge({ size = 14, title = "حِساب مُوَثَّق بِبِطاقة نِقابة المحامين", testid = "verified-badge" }) {
  return (
    <span
      aria-label={title}
      title={title}
      data-testid={testid}
      className="inline-flex items-center justify-center"
    >
      <SealCheck size={size} weight="fill" className="text-[#1D9BF0] drop-shadow-[0_0_2px_rgba(29,155,240,0.45)]" />
    </span>
  );
}

export function GradeChip({ grade, full, color, size = "sm" }) {
  if (!grade) return null;
  const pad = size === "xs" ? "px-1.5 py-0.5 text-[9.5px]" : "px-2 py-0.5 text-[10.5px]";
  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full font-bold border ${pad}`}
      style={{ color, borderColor: `${color}88`, background: `${color}14` }}
      data-testid="grade-chip"
    >
      <span className="font-amiri text-[12px] leading-none">{grade}</span>
      {full && <span className="leading-none">{full}</span>}
    </span>
  );
}
